import { render } from "./SidebarLayout.vue?vue&type=template&id=50112d8c"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/classic/SidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50112d8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50112d8c', __exports__)) {
    api.reload('50112d8c', __exports__)
  }
  
  module.hot.accept("./SidebarLayout.vue?vue&type=template&id=50112d8c", () => {
    api.rerender('50112d8c', render)
  })

}


export default __exports__